module.exports = __webpack_public_path__ + "img/arrow-blue.5bcea0cb.svg";